import axios from "axios";
import Cook from "./cookie";
import store from "../store";
import { Message } from "element-ui";
import { language } from "../language/get";
const lang = language();
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url 修改当前访问地址
  timeout: process.env.NODE_ENV === "development" ? 0 : 10000  //请求响应时间
});
export default {
  /**
   *
   * 后台API接口地址
   正式
   */
  adminapi: 'https://exhxcx.shippingchina.com/adminapi.php/Home/',
  /**
  测试
  */
   //adminapi: 'https://exhixcx.shippingchina.com/adminapi.php/Home/',
  /**
   *
   * @param url 地址
   * @param param 参数
   * @param isEn 是否包含中英文
   * @returns {Promise<unknown>}
   */
  send: function (url, param, isEn) {
    var lan = Cook.get("lang");
    // 线上
    url = "https://exhxcx.shippingchina.com/api.php/Home" + url;
    // 测试

    if(url.indexOf('http') == -1){
      //url = "https://exhixcx.shippingchina.com/api.php/Home" + url;
    }
    if (isEn == true && lan == "en") {
      url = url + "_En"
    }
    return new Promise(function (resolve) {
      axios.post(url, param, {}).then(function (result) {
        var res = result.data;
        if (res.type == "-1") {
          Message.error({
            message: lang.overtime,
            offset: 120,
            duration: 5000
          })
          Cook.del("token");
          store.dispatch("Logout", { token: store.getters.token });
          window.location.href = "login.html"
          return;
        }
        resolve(res);
      })
    })
  }
};
